<template>
  <div>
    <!-- <search-bar
      @search="searchOutMonth"
      name="pi_inoutno,pi_custname,pi_remark"
      placeholder="输入单据编号、客户、备注进行查找"
      ref="searchBar"
    /> -->

    <year-filter-bar @change="onYearChange" ref="yearFilterBar" />

    <div class="canvas-box">
      <canvas id="myChart" class="myChart"></canvas>
    </div>

    <div class="list-box">
      <div class="list-box-nav">
        <span
          :class="selected == '全部' ? 'selected' : ''"
          @click="toggle('全部', 'detail')"
          >全部</span
        >
        <div
          :class="selected == '业务员' ? 'selected' : ''"
          @click="toggle('业务员', 'seller')"
        >
          业务员
        </div>
        <span
          :class="selected == '客户' ? 'selected' : ''"
          @click="toggle('客户', 'cust')"
          >客户</span
        >
        <span
          :class="selected == '客户类型' ? 'selected' : ''"
          @click="toggle('客户类型', 'custtype')"
          >客户类型</span
        >
        <span
          :class="selected == '物料' ? 'selected' : ''"
          @click="toggle('物料', 'prod')"
          >物料</span
        >
        <span
          :class="selected == '厂家品牌' ? 'selected' : ''"
          @click="toggle('厂家品牌', 'brand')"
          >厂家品牌</span
        >
      </div>
      <div class="weui-cells">
        <div
          class="weui-cell"
          :class="querytype != 'detail' ? 'weui-cell_access' : ''"
          v-for="(item, index) in list"
          :key="index"
          @click="onChangeChart(item)"
        >
          <div class="weui-cell__bd">
            <p v-if="querytype == 'detail'">{{ item.label }}</p>
            <p v-if="querytype == 'brand'">{{ item.pr_brand }}</p>
            <p v-if="querytype == 'seller'">{{ item.pi_seller }}</p>
            <p v-if="querytype == 'cust'">{{ item.pi_custname }}</p>
            <p v-if="querytype == 'custtype'">{{ item.cu_type }}</p>
            <p v-if="querytype == 'prod'">{{ item.pr_detail }}</p>
            <p v-if="querytype == 'prod'">{{ item.pr_code }}</p>
          </div>
          <div class="weui-cell__ft">
            <p
              v-if="querytype == 'detail'"
              :class="item.label != '本年累计' ? 'link' : ''"
              @click.stop="openDetails(item)"
            >
              {{ item.num }}
            </p>
            <p class="link" v-else @click.stop="openDetails(item)">
              {{ item.amount }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import YearFilterBar from "@/components/YearFilterBar.vue";
// import F2 from '@antv/f2'
import F2 from "@antv/f2/lib/index";
import ScrollBar from "@antv/f2/lib/plugin/scroll-bar";
import "@antv/f2/lib/interaction/pan";

export default {
  components: {
    YearFilterBar,
  },
  data() {
    let year = new Date().getFullYear();

    return {
      result: {},
      list: [], // 销售出货分析底部列表的数据
      year,
      querytype: "detail",
      selected: "全部",
      chart: null,
    };
  },
  mounted() {
    this.searchOutMonth();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    openDetails(item) {
      let params = null,
        date = "",
        query = null;
      if (item.label == "本年累计") {
        return;
      }
      if (this.querytype == "seller") {
        query = item.pi_seller;
      }
      if (this.querytype == "brand") {
        query = item.pr_brand;
      }
      if (this.querytype == "cust") {
        query = item.pi_custname;
      }
      if (this.querytype == "custtype") {
        query = item.cu_type;
      }
      if (this.querytype == "prod") {
        query = item.pr_detail;
      }
      if (this.querytype == "detail") {
        let str = "",
          m = "";
        str = item.label.slice(0, -1);
        m = Number(str) > 9 ? str : "0" + str;
        date =
          this.year +
          "-" +
          m +
          "-01 00:00:00," +
          this.year +
          "-" +
          m +
          "-31 23:59:59";
      } else {
        date = this.year + "-01-01 00:00:00," + this.year + "-12-31 23:59:59";
      }

      params = {
        date: date,
        keyword: query,
      };

      this.$emit("toggle", "明细", params);
    },
    searchOutMonth() {
      let me = this;

      me.$ajax({
        url: "/api/storage/report/saleOutMonth",
        params: {
          year: me.year,
          querytype: me.querytype,
        },
      }).then(function (res) {
        if (res.success) {
          me.result = res.data;
          me.initChart(me.deal(me.result.monthitems));
          me.initList();
        }
      });
    },
    onResize() {
      var chart = this.chart;
      if (chart) {
        this.chart = chart.destroy();
        this.initChart(this.deal(this.result.monthitems));
      }
    },
    initChart(data) {
      var chart = this.chart;
      if (chart) {
        this.updateChart(data);
        return;
      }

      this.chart = chart = new F2.Chart({
        id: "myChart",
        width: window.innerWidth,
        height: Math.min(window.innerHeight * 0.6, 300),
        pixelRatio: window.devicePixelRatio,
        plugins: ScrollBar,
      });

      chart.source(data, {
        index: {
          type: "linear",
          tickInterval: 1,
          min: -1,
          max: window.innerWidth > window.innerHeight ? 12 : 6,
          formatter: (i) =>
            i > -1 && i < 12
              ? [
                  "01月",
                  "02月",
                  "03月",
                  "04月",
                  "05月",
                  "06月",
                  "07月",
                  "08月",
                  "09月",
                  "10月",
                  "11月",
                  "12月",
                ][i]
              : null,
        },
      });

      chart
        .interval()
        .position("index*value")
        .color("type", (val) => {
          if (val === "金额") {
            return "#2eadf5";
          }
        })
        .adjust({
          type: "dodge",
          marginRatio: 0.05, // 设置分组间柱子的间距
        });
      data.forEach((item) => {
        if (item.value) {
          chart.guide().text({
            position: [item.index, item.value],
            content: item.value,
            style: {
              fill: "#808080",
              textAlign: "center",
            },
            offsetY: -10,
          });
        }
      });
      if (window.innerWidth < window.innerHeight) {
        // 定义进度条
        chart.scrollBar({
          mode: "x",
          xStyle: {
            backgroundColor: "#e8e8e8",
            fillerColor: "#808080",
            offsetY: -2,
          },
        });
      }
      chart.interaction("pan");
      chart.render();
    },
    updateChart(newData) {
      var chart = this.chart;
      // 1. 更新数据源
      chart.changeData(newData);

      // 2. 清除所有 Guide 元素
      chart.guide().clear();

      // 3. 重新添加 Guide（根据新数据动态生成）
      newData.forEach((item) => {
        if (item.value) {
          chart.guide().text({
            position: [item.index, item.value],
            content: item.value,
            style: {
              fill: "#808080",
              textAlign: "center",
            },
            offsetY: -10,
          });
        }
      });

      // 4. 重新渲染
      chart.repaint();
    },
    onChangeChart(item) {
      if (this.querytype == "detail") return;

      let arr = [
        { index: -1, type: item.text, value: 0 },
        { index: 12, type: item.text, value: 0 },
      ];
      for (let i = 0; i < 12; i++) {
        arr.push({
          index: i,
          text: i + "月",
          type: item.text,
          value: item["amount" + (i + 1)] || 0,
        });
      }
      this.initChart(arr);
    },
    initList() {
      if (this.querytype == "detail") {
        let data = this.result.details[0],
          arr = [];
        for (let i = 0; i < 13; i++) {
          if (i < 12) {
            arr[i] = {
              label: i + 1 + "月",
              num: data["amount" + (i + 1)],
            };
          } else {
            arr[i] = {
              label: "本年累计",
              num: data["amount"],
            };
          }
        }
        this.list = arr;
      } else {
        this.list = this.result.details;
      }
    },
    toggle(val, querytype) {
      this.selected = val;
      this.querytype = querytype;
      this.searchOutMonth();
    },
    onYearChange(year) {
      this.year = year;
      this.searchOutMonth();
    },
    deal(data) {
      if (!data) return;

      const textArr = [
        "01月",
        "02月",
        "03月",
        "04月",
        "05月",
        "06月",
        "07月",
        "08月",
        "09月",
        "10月",
        "11月",
        "12月",
      ];

      let arr = [
        { index: -1, type: "金额", value: 0 },
        { index: 12, type: "金额", value: 0 },
      ];
      data.forEach((item, i) => {
        arr.push({
          text: item.text,
          type: "金额",
          index: i,
          value: item.amount || 0,
        });
      });
      const l = arr.length / 3;
      if (l < 12) {
        for (let i = l; i < 12; i++) {
          arr.push({
            index: i,
            text: textArr[i],
            type: "金额",
            value: 0,
          });
        }
      }
      return arr;
    },
  },
};
</script>

<style scoped>
.canvas-box {
  /* width: 200%; */
  overflow-x: scroll;
  /* height: 100%; */
  background: var(--weui-BG);
}

.list-box {
  margin-top: 5px;
  background: var(--weui-BG);
}
.list-box-nav {
  width: 100%;
  padding: 10px 10px 0;
  box-sizing: border-box;
  font-size: 13px;
  color: var(--weui-FG);
  display: flex;
  justify-content: space-around;
}
.selected {
  font-weight: 600;
  border-bottom: 2px solid var(--weui-FG);
}
.link {
  text-decoration: underline;
  color: #23a8f2;
}
@media screen and (min-width: 500px) {
  .filter-bar {
    padding: 6px 0 2px 0;
  }
}
</style>